import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader } from "@themes/pollinator/ui/Loader";
import { useIsLoginDisabled } from "@platform/hooks/useIsLoginDisabled";

export type Props = {
  children: ReactNode;
  /** Where somebody goes instead while login is closed */
  to?: string;
};

/**
 * Closes a way of signing in while staff have switched participants' login
 * off, sending whoever arrives somewhere else, the homepage unless told.
 *
 * Every page that needs signing in sends a stranger to the login page, so
 * closing that one page is what turns them all, the footer's Support link
 * among them, toward the homepage.
 */
export function LoginClosedGate({ children, to = "/" }: Props) {
  const { isLoginDisabled, isLoading } = useIsLoginDisabled();

  if (isLoading) {
    return <Loader isFullPage />;
  }

  if (isLoginDisabled) {
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}

export default LoginClosedGate;
